import { action } from "typesafe-actions";

export enum actionTypes {
  SAVE_COORDINATES = "SAVE_COORDINATES"
}

type Location = {
  country?: string,
  city?: string
}

export const coordinateActions = {
  save: (lat: number, lng: number, country: string) => action(actionTypes.SAVE_COORDINATES, { lat, lng, country })  // action(type,payload)
}